export type SetupTone = 'wait' | 'ok' | 'info' | 'amber' | 'danger';

export interface StoreSetupStatus {
  id: string;
  name: string;
  key: string;
  tone: SetupTone;
  system: boolean;
}

export interface StoreSetupQuery {
  fieldId: string;
  operator: string;
  values: string[];
  label?: string;
}

export interface StoreSetupSearch {
  id: string;
  name: string;
  detail: string;
  dashboard: boolean;
  window: 'today' | null;
  query: StoreSetupQuery | null;
}

export interface StoreSetupChart {
  id: string;
  name: string;
  chartType: string;
  field: string;
  aggregation: string;
  valueField: string | null;
  searchId: string | null;
}

export interface StoreSetupAction {
  type: string;
  label: string;
  config: Record<string, string>;
}

export interface StoreSetupAutomation {
  id: string;
  name: string;
  summary: string;
  trigger: { type: string; label: string };
  criteria: StoreSetupQuery[];
  actions: StoreSetupAction[];
}

export interface StoreSetupField {
  id: string;
  name: string;
  type: string;
}

export interface StoreSetupDraft {
  profile: 'cod' | 'simple' | null;
  statuses: StoreSetupStatus[];
  searches: StoreSetupSearch[];
  charts: StoreSetupChart[];
  automations: StoreSetupAutomation[];
  fields: StoreSetupField[];
}

export interface StoreSetupIncluded {
  fields: string[];
  roles: string[];
}

export interface StoreSetupPreview {
  setup: StoreSetupDraft;
  message: string;
  placed: string[];
  focus: string | null;
  storeName: string | null;
  included: StoreSetupIncluded;
}

export interface StoreSetupPreviewResponse {
  success: boolean;
  data?: StoreSetupPreview;
  error?: { message?: string };
}

export const EMPTY_STORE_SETUP: StoreSetupDraft = {
  profile: null,
  statuses: [],
  searches: [],
  charts: [],
  automations: [],
  fields: []
};

export const SETUP_INCLUDED: StoreSetupIncluded = {
  fields: ['Nom du client', 'Téléphone', 'Email', 'Adresse', 'Montant total', 'Notes'],
  roles: ['Owner', 'Admin', 'Member']
};

export const SETUP_DEFAULT_STATUSES = [
  'En attente',
  'Confirmé',
  'En traitement',
  'Expédié',
  'Livré',
  'Annulé'
];
